import { createAction } from '@ngrx/store';

/**
 * Actions für den Logout-Dialog.
 */
export class LogoutDialogActions {
  private static readonly prefix = '[Dialog Logout]';

  /**
   * Öffnet den Dialog.
   */
  public static open = createAction(
    `${this.prefix} Open dialog`,
  );

  /**
   * Bestätigt die Abmeldung.
   */
  public static confirm = createAction(
    `${this.prefix} Confirm logout`,
  );

  /**
   * Schließt den Dialog.
   */
  public static close = createAction(
    `${this.prefix} Close dialog`,
  );
}
